import { api } from './index';

const prefix = '/api/auth/';

export function apiLogin(user_id, password) {
	//console.log(process.env.NODE_ENV);
	//console.log(api.defaults.baseURL);
	return api.post(prefix + 'login', {
		host: window.location.host,
		//default_company_id: 'beautyplus',
		user_id: user_id,
		password: password,
	});
}

export function apiTest() {
	return api.get('/api/test');
}

export function apiLogout() {
	return api.get(prefix + 'logout');
}

export function apiGetUsername() {
	return api.get(prefix + 'getUsername');
}
